interface IOrganizationAuctionDonor {
	id: number;
	name: string;
	logo?: string;
	logoUrl?: string | File;
}

const generateProductId = () => {
	const timestamp = Date.now();
	const random = Math.floor(Math.random() * 1000);
	return Number(`${timestamp}${random}`);
};

export const handleGetDonors = (
	donors: IOrganizationAuctionDonor[] | null,
	editableDonor: IOrganizationAuctionDonor | null,
	donorLogo: File | string | null,
	donorName: string
) => {
	const updatedDonors = (donors || []).map((donor) =>
		editableDonor && donor.id === editableDonor.id ? {...donor, logoUrl: donorLogo, name: donorName} : donor
	);

	if (!editableDonor) {
		updatedDonors.push({
			id: generateProductId(),
			logoUrl: donorLogo,
			name: donorName,
		});
	}

	return updatedDonors;
};
